if (!window.Eurus.loadedScript.includes('speech-search.js')) {
  window.Eurus.loadedScript.push('speech-search.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data('xSpeechSearch', (el) => ({
        recognition: null,
        isListening: false,
        searchInput: null,
        searchBtn: null,
        statusEl: null,
        idleLabel: '',
        show: false,
        initSpeechSearch() {
          const userAgent = window.navigator.userAgent.toLowerCase();
          if ('webkitSpeechRecognition' in window
            && userAgent.indexOf('chrome') > -1 && !!window.chrome
            && userAgent.indexOf('edg/') === -1) {
            this.show = true;
            this.recognition = new window.webkitSpeechRecognition();
            this.recognition.continuous = false;
            this.recognition.interimResults = true;
            const form = el.closest('form');
            this.searchInput = form.querySelector('.input-search');
            this.searchBtn = form.querySelector('.btn-search');
            this.idleLabel = el.getAttribute('aria-label') || 'חיפוש קולי';
            const next = el.nextElementSibling;
            this.statusEl = (next && next.matches('.sr-only[aria-live]')) ? next : null;
            this.bindEvents();
          } else {
            this.show = false;
          }
        },

        announce(message) {
          if (!this.statusEl) return;
          this.statusEl.textContent = '';
          requestAnimationFrame(() => {
            this.statusEl.textContent = message;
          });
        },

        setListeningState(listening) {
          this.isListening = listening;
          el.classList.toggle('search__speech-listening', listening);
          el.setAttribute('aria-pressed', listening ? 'true' : 'false');
          el.setAttribute('aria-label', listening ? 'הפסקת חיפוש קולי' : this.idleLabel);
        },

        bindEvents() {
          this.recognition.addEventListener(
            'result',
            (evt) => {
              if (evt.results) {
                const term = evt.results[0][0].transcript;
                this.searchInput.value = term;
                this.searchInput.dispatchEvent(new Event('keyup'));
                el.blur();
                this.searchBtn.focus();
              }
            }
          );
  
          this.recognition.addEventListener('audiostart', () => {
            this.setListeningState(true);
            this.announce('מאזין…');
          });
  
          this.recognition.addEventListener('audioend', () => {
            this.setListeningState(false);
            this.announce('ההקלטה הסתיימה');
          });

          this.recognition.addEventListener('error', () => {
            this.setListeningState(false);
            this.announce('לא ניתן להפעיל חיפוש קולי');
          });
  
          el.addEventListener('click', (e)=> this.toggleListen(e));
        },
  
        toggleListen(evt) {
          evt.preventDefault();
          if (this.isListening) {
            this.recognition.stop();
          } else {
            try {
              this.recognition.start();
            } catch (e) {
              this.setListeningState(false);
              this.announce('לא ניתן להפעיל חיפוש קולי');
            }
          }
        }
      }))
    });
  });
}
